import dataProvider from "src/dataProvider";

const fetcher = dataProvider("adminInstance");

export interface PaymentListQuery {
  offset?: number;
  limit?: number;
  status?: string;
  searchText?: string;
  entityIds?: string;
}

export interface GenerateDemandNotePayload {
  epid: string;
  demandNoteDocumentKey: string;
  demandNoteDocumentName?: string;
  demandNoteAmount: number;
  demandNoteDueDate?: string;
}

export interface UploadReceiptPayload {
  epid: string;
  receiptDocumentKey: string;
  receiptDocumentName?: string;
  transactionReference?: string;
  transactionDate?: string;
  paymentMode?: string;
}

export interface VerifyPaymentPayload {
  epid: string;
  action: "APPROVE" | "REJECT";
  rejectionRemark?: string;
  remark?: string;
}

export interface CreatePaymentQueryPayload {
  epid: string;
  query: string;
}

export const getPayments = async (params: PaymentListQuery) => {
  return fetcher.get<any>("/payments", params);
};

export const getPaymentByEpid = async (epid: string) => {
  return fetcher.get<any>(`/payments/epid/${epid}`);
};

export const generateDemandNote = async (data: GenerateDemandNotePayload) => {
  return fetcher.post<GenerateDemandNotePayload, any>(
    "/payments/generate-demand-note",
    data
  );
};

export const uploadReceipt = async (data: UploadReceiptPayload) => {
  return fetcher.post<UploadReceiptPayload, any>(
    "/payments/upload-receipt",
    data
  );
};

export const verifyPayment = async (data: VerifyPaymentPayload) => {
  return fetcher.post<VerifyPaymentPayload, any>("/payments/verify", data);
};

export const createPaymentQuery = async (data: CreatePaymentQueryPayload) => {
  return fetcher.post<CreatePaymentQueryPayload, any>(
    "/payments/query",
    data
  );
};
